var Actions;
(function (Actions) {
    Actions["ADD_BODY_CLASSNAME"] = "addBodyClassName";
    Actions["REMOVE_BODY_CLASSNAME"] = "removeBodyClassName";
    Actions["SET_BREADCRUMB_ACTION"] = "setBreadcrumbAction";
    Actions["GET_MENU"] = "GET_MENU";
    Actions["LOGIN_INFO"] = "LOGIN_INFO";
    Actions["ADD_BODY_ATTRIBUTE"] = "addBodyAttribute";
    Actions["SET_IS_SIDE_ACTIVE"] = "setIsSideActiveAction";
    Actions["LOGIN"] = "login";
    Actions["LOGOUT"] = "logout";
    Actions["ACTIVE_PAGE"] = "activePage";
    Actions["SIDE_MENU"] = "SIDE_MENU";
    Actions["GET_PROFILE"] = "GET_PROFILE";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["OVERRIDE_LAYOUT_CONFIG"] = "overrideLayoutConfig";
    Mutations["SET_FCM_TOKEN"] = "SET_FCM_TOKEN";
    Mutations["SET_SIDE_MENU"] = "SET_SIDE_MENU";
    Mutations["PURGE_AUTH"] = "logOut";
    Mutations["SET_ASIDE_FILTER"] = "SET_ASIDE_FILTER";
    Mutations["SET_AUTOSAVE_DRAFT"] = "setAutoSaveDraft";
    Mutations["SET_LANDING_FILTER"] = "SET_LANDING_FILTER";
    Mutations["SET_AUTH"] = "setAuth";
    Mutations["SET_ERROR"] = "setError";
    Mutations["SET_BREADCRUMB_MUTATION"] = "setBreadcrumbMutation";
    Mutations["RESET_LAYOUT_CONFIG"] = "resetLayoutConfig";
    Mutations["SET_ACTIVE_PAGE"] = "setActivePage";
    Mutations["SET_USER_INFO"] = "setUserInfo";
    Mutations["RESET_MENU_LIST"] = "resetMenuList";
    Mutations["SET_IS_SIDE_ACTIVE"] = "setIsSideActive";
    Mutations["SET_LANDING_MENU"] = "SET_LANDING_MENU";
})(Mutations || (Mutations = {}));
var CACHES;
(function (CACHES) {
    CACHES["TOKEN"] = "id_token";
    CACHES["TOKEN_EXPIRES"] = "id_token_expires";
    CACHES["MENU"] = "id_menu";
    CACHES["USER"] = "id_user";
})(CACHES || (CACHES = {}));
export { Actions, Mutations, CACHES };
